import { useEffect, useState } from 'react';
import { TimeContext } from './TimeContext';

const VISIBLE = 'visible';

export const TimeProvider = ({ children }: { children: any }) => {
  const [time, setTime] = useState<Date>(() => new Date());
  const [visibilityState, setVisibilityState] = useState<string>(
    () => document.visibilityState ?? VISIBLE
  );

  useEffect(() => {
    if (document.visibilityState === undefined) {
      return;
    }
    const handler = () => {
      const state = document.visibilityState;
      if (state === VISIBLE) {
        setTime(new Date()); // Перерисуем время сразу по возвращению со вкладки. Таймер сработает на секунду позже.
      }
      setVisibilityState(state);
    };
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);

  useEffect(() => {
    if (visibilityState !== VISIBLE) {
      return;
    }
    const intervalId = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(intervalId);
  }, [visibilityState]);

  return <TimeContext.Provider value={time}>{children}</TimeContext.Provider>;
};
